<template>
    <div class="fill-height" v-if="!demoObject">
        <v-container>
            <v-card>
                <v-card-title>
                    <v-icon class="mr-2">error</v-icon>
                    <h2>Deze demo bestaat (nog) niet</h2>
                </v-card-title>
                <v-btn :to="{ name: 'home' }">Ga terug naar home</v-btn>
            </v-card>
        </v-container>
    </div>
    <div class="fill-height" v-else>
        <v-container v-if="!demoObject.hideHeader">
            <v-layout row align-start>
                <v-icon x-large class="mr-3">{{ demoObject.icon }}</v-icon>
                <div>
                    <h2>{{ demoObject.name }}</h2>
                    <p>{{ demoObject.description }}</p>
                </div>
            </v-layout>
        </v-container>
        <component :is="demoComponent" />
    </div>
</template>

<script>
export default {
    data () {
        return {
            demoLoaded: false,
        }
    },
    props: {
        demo: {
            type: String,
            required: true,
        },
    },
    computed: {
        demoObject () {
            return this.$store.getters.demo(this.demo)
        },
        demoComponent () {
            return this.$store.getters.demoComponent(this.demo)
        },
    },
}
</script>
